import type { ConversationItemNameProps } from './types';
import * as React from 'react';
import { Popup } from 'semantic-ui-react';
import { cn } from '~/lib/utils';

export const ConversationItemName: React.FC<ConversationItemNameProps> = ({
  bold = false,
  emoji,
  isOwnChat = false,
  subtitle,
  title,
  isInactive = false,
}) => (
  <div
    data-private
    className={cn(
      'flex flex-col min-w-0 text-[16px] leading-[21px] text-foreground font-sans font-normal whitespace-nowrap',
      { 'font-bold': bold }
    )}
  >
    <div className={cn('flex min-w-0')}>
      <span className={cn('truncate')}>{title}</span>
      {isOwnChat && <span className={cn('ml-[5px]')}>{'(You)'}</span>}
      {isInactive && <span className={cn('ml-[5px]')}>{'[Inactive]'}</span>}
      {emoji?.title && (
        <Popup
          inverted
          trigger={<span className={cn('ml-[10px]')}>{emoji.title}</span>}
          content={emoji?.message || ''}
          position="top right"
        />
      )}
    </div>
    {subtitle && (
      <div className={cn('text-[13px] leading-[18px]')}>{subtitle}</div>
    )}
  </div>
);
